"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudienceSizeRequestToJSON = exports.AudienceSizeRequestFromJSONTyped = exports.AudienceSizeRequestFromJSON = exports.instanceOfAudienceSizeRequest = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the AudienceSizeRequest interface.
 */
function instanceOfAudienceSizeRequest(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAudienceSizeRequest = instanceOfAudienceSizeRequest;
function AudienceSizeRequestFromJSON(json) {
    return AudienceSizeRequestFromJSONTyped(json, false);
}
exports.AudienceSizeRequestFromJSON = AudienceSizeRequestFromJSON;
function AudienceSizeRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'isGuarantee': !(0, runtime_1.exists)(json, 'is_guarantee') ? undefined : json['is_guarantee'],
        'adSetIds': !(0, runtime_1.exists)(json, 'ad_set_ids') ? undefined : json['ad_set_ids'],
    };
}
exports.AudienceSizeRequestFromJSONTyped = AudienceSizeRequestFromJSONTyped;
function AudienceSizeRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'is_guarantee': value.isGuarantee,
        'ad_set_ids': value.adSetIds,
    };
}
exports.AudienceSizeRequestToJSON = AudienceSizeRequestToJSON;
